import { useStrictLocalization } from "@faire/web/common/localization";
import { Row } from "@faire/web/slate/Layout";
import React from "react";

import { AccessibleStarsDescriptionProps } from "./index.d";

export const AccessibleStarsDescription: React.FC<
  AccessibleStarsDescriptionProps
> = ({ rating, children, "data-test-id": dataTestId }) => {
  const { strictLocalize } = useStrictLocalization();

  return (
    <Row
      data-test-id={dataTestId}
      aria-label={strictLocalize(
        {
          defaultMessage:
            "{starsNumber, plural, one{# of 5 stars} other{# of 5 stars}}",
          description: {
            text: "Describes a set of 5 stars, partially shaded in to represent a rating. The number of stars may be a decimal.",
          },
        },
        { starsNumber: rating }
      )}
      role="img"
    >
      <div aria-hidden="true">{children}</div>
    </Row>
  );
};
